import React from 'react';
import Newsletter from '../components/Newsletter';
import { programmes } from '../mock';

const Programmes = () => (
  <div>
    <section className="relative overflow-hidden bg-[#0c1119] pt-36 pb-16 border-b border-white/10">
      <img src="/events/programmes-hero.png" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a0e16] via-[#0a0e16]/70 to-[#0a0e16]/15" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e16] via-transparent to-transparent" />
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10 max-w-3xl fade-up">
        <span className="dctv-eyebrow text-[#e8743b]">What we make</span>
        <h1 className="font-serif-dctv text-5xl md:text-6xl font-bold text-white mt-4">Programmes &amp; themes</h1>
        <p className="text-[#e7e9ee]/75 text-lg leading-relaxed mt-5 max-w-2xl">
          Thematic debates, forums and stories that build understanding and inclusion across the global village.
        </p>
      </div>
    </section>

    <section className="px-6 lg:px-10 py-16">
      <div className="max-w-[1400px] mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {programmes.map((p) => (
          <div key={p.num} className="dctv-card rounded-2xl p-8 group">
            <span className="font-serif-dctv text-3xl text-[#e8743b] font-semibold">{p.num}</span>
            <h3 className="font-serif-dctv text-2xl font-semibold text-white mt-3 group-hover:text-[#f4965a] transition-colors">{p.title}</h3>
            <p className="text-[#9aa3b2] text-sm leading-relaxed mt-4">{p.text}</p>
          </div>
        ))}
      </div>
    </section>

    <Newsletter />
  </div>
);

export default Programmes;
